var _path, _ellipse, _circle, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.16178 10.3514C3.60942 8.11322 3.83325 6.99412 4.5728 6.27334C4.70949 6.14013 4.85737 6.0189 5.0148 5.91099C5.86662 5.32715 7.00789 5.32715 9.29041 5.32715H10.7095C12.9921 5.32715 14.1333 5.32715 14.9851 5.91099C15.1426 6.0189 15.2905 6.14013 15.4271 6.27334C16.1667 6.99412 16.3905 8.11322 16.8382 10.3514C17.4808 13.5648 17.8022 15.1714 17.0624 16.3099C16.9285 16.5161 16.7722 16.7068 16.5963 16.8785C15.625 17.8271 13.9865 17.8271 10.7095 17.8271H9.29041C6.01344 17.8271 4.37495 17.8271 3.40364 16.8785C3.22777 16.7068 3.07144 16.5161 2.9375 16.3099C2.19778 15.1714 2.51912 13.5648 3.16178 10.3514Z",
    stroke: "#858585",
    strokeWidth: 1.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 12.5013,
    cy: 7.82747,
    rx: 0.833333,
    ry: 0.833333,
    fill: "#858585"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 7.5013,
    cy: 7.82747,
    r: 0.833333,
    fill: "#858585"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M7.5 5.32747V4.49414C7.5 3.11343 8.61929 1.99414 10 1.99414C11.3807 1.99414 12.5 3.11343 12.5 4.49414V5.32747",
    stroke: "#858585",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderIcon);
export default __webpack_public_path__ + "static/media/OrderIcon.e01858ea1e96ed0a87658ca01f64fe41.svg";
export { ForwardRef as ReactComponent };